import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { ConsumerLogService } from "../../../services/api/consumer-log.service";
import { ConsumerTransactionActions } from "../../actions/consumer-log.actions";
import { AchDocumentState } from "../../models/consumer-logs/ach-document-state";
import { FailState } from "../../models/fail-state";
import { AppState } from "../../reducers";
import { ConsumerTransactionSelectors } from "../../selectors/consumer-transaction.selectors";

@Injectable()
export class AchBoStatusEffects {
	requested = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerTransactionActions.achBoStatus.get),
			withLatestFrom(this.store.select(ConsumerTransactionSelectors.achDocs)),
			switchMap(([action, state]) =>
				AchBoStatusEffects.canUseStoreValue(state)
					? of(ConsumerTransactionActions.achBoStatus.getSuccess(state))
					: of(ConsumerTransactionActions.achBoStatus.getApi())
			)
		)
	);

	apiRequested = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerTransactionActions.achBoStatus.getApi),
			switchMap(() =>
				this.consumerLogService.achBeneficialOwnerStatus().pipe(
					map((statuses) =>
						ConsumerTransactionActions.achBoStatus.getSuccess({
							statuses,
							loading: false
						})
					),
					catchError((error) =>
						of(ConsumerTransactionActions.achBoStatus.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerLogService: ConsumerLogService,
		private store: Store<AppState>
	) {}

	private static canUseStoreValue(state: AchDocumentState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
